import React, {Component} from 'react';
import Link from 'react-router-dom/Link'
import icons from '../services/icons.js';
import bodymovin from 'bodymovin';
import './serviceblock.css';
import get from 'lodash.get';
import has from 'lodash.has';


class Serviceblock extends Component {

    constructor(props) {
        super(props);

        this.state = {play: false};

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    componentDidMount() {
        if (has(this, 'props.icon') && has(icons, get(this, 'props.icon'))) {
            var serviceblock = this.refs.serviceblock;

            this.animation = bodymovin.loadAnimation({
                container: serviceblock,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                animationData: get(icons, get(this, 'props.icon'))
            });


            this.animation.addEventListener('loopComplete', () => {
                if (this.state.play === false) {
                    this.animation.stop();
                }
            });
        }

    }

    onMouseEnter() {
        if (has(this, 'animation')) {
            this.setState({play: true});
            this.animation.play();
        }
    }

    onMouseLeave() {
        if (has(this, 'animation')) {
            this.setState({play: false});
        }
    }

    render() {
        let itemId = `serviceblock-${this.props.id}`;

        return (
            <div className="serviceblock" id={itemId} style={{backgroundImage: `url('${this.props.image}')`}}
                 onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <Link to={`/dienst/${this.props.slug}`}>
                    <div className="serviceblock__details">
                        <div className="serviceblock__title" dangerouslySetInnerHTML={{__html: this.props.title}}/>
                        <div className="serviceblock__icon" ref="serviceblock">

                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}

export default Serviceblock;



// WEBPACK FOOTER //
// ./src/components/serviceblock/serviceblock.js